import React, { useEffect, useState } from "react";
import Box from "./Box";

const List = (props) => {

    const [days, setDays] = useState(new Map())

    useEffect(() => {
        const groups = new Map()
        props.list?.forEach((item) => {
            const dayKey = item?.date ? parseInt(item?.date.substring(8, 10), 10) : null;

            if (!groups.has(dayKey)) {
                groups.set(dayKey, []);
            }
            groups.get(dayKey).push(item);
        })
        setDays(groups)
    }, [props.list])

    return (
        <div className="w-full flex flex-col gap-4">
            { Array.from(days.entries()).map(([key, value]) =>
                <div className={ "flex gap-[9px] w-full" }>
                    <div className={ "CalendarListDayContainer" }>
                        <div className={ "CalendarListDate" }>{ props.date.toLocaleString("default", {
                            month: "short",
                        }) } { key }</div>
                        <div
                            className={ "CalendarListDay" }>{ new Intl.DateTimeFormat("en-US", {weekday: "long"}).format(new Date(props.date?.getFullYear(), props.date?.getMonth(), key)) }</div>
                    </div>
                    <div className={ "flex flex-col w-full gap-3" }>
                        { value?.map((item) =>
                            <Box item={ item } handleRevenue={ props.handleRevenue }
                                 handleSchedulePopup={ props.handleSchedulePopup }
                                 day={ key }
                                 date={ new Date(props.date?.getFullYear(), props.date?.getMonth(), key) }
                                 handleDeleteSchedule={ props.handleDeleteSchedule }
                                 handleCancelSchedule={ props.handleCancelSchedule }></Box>
                        ) }
                    </div>
                </div>
            ) }
        </div>
    )
}

export default List;